"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledArrowForward = exports.StyledTappableCard = void 0;
const styles_1 = require("@mui/material/styles");
const ArrowForward_1 = __importDefault(require("../icon/svgs/ArrowForward"));
const tappable_card_1 = __importStar(require("../tappable-card"));
const button_1 = require("../button");
exports.StyledTappableCard = (0, styles_1.styled)(tappable_card_1.default)(({ theme }) => ({
    [`&.${tappable_card_1.tappableCardClasses.root}`]: {
        flexDirection: "column-reverse",
        borderRadius: "3px",
        [theme.breakpoints.down("sm")]: {
            flexDirection: "row",
            alignItems: "center"
        }
    },
    [`.${tappable_card_1.tappableCardClasses.cardButton}`]: {
        flexDirection: "column-reverse",
        [`&.${button_1.buttonClasses.text}:hover`]: { backgroundColor: theme.colours.pearl },
        [theme.breakpoints.down("sm")]: {
            flexDirection: "row",
            alignItems: "center",
            width: "100%"
        }
    },
    [`.${tappable_card_1.tappableCardClasses.headerPicture}`]: {
        maxHeight: "140px",
        borderRadius: "0 0 3px 3px",
        [theme.breakpoints.down("sm")]: {
            minHeight: "80px",
            height: "100%",
            maxHeight: "100%",
            width: "80px",
            borderRadius: "3px 0 0 3px",
            display: "inline-table"
        }
    },
    [`.${tappable_card_1.tappableCardClasses.body}`]: {
        padding: "20px",
        minHeight: "100px",
        justifyContent: "center",
        [theme.breakpoints.down("md")]: {
            minHeight: "80px"
        },
        [theme.breakpoints.down("sm")]: {
            padding: "0"
        }
    },
    [`.${tappable_card_1.tappableCardClasses.title}`]: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        wordWrap: "unset",
        [theme.breakpoints.down("sm")]: {
            padding: "20px 20px 20px 16px",
            justifyContent: "start"
        }
    }
}));
exports.StyledArrowForward = (0, styles_1.styled)(ArrowForward_1.default)({
    marginLeft: "12px",
    width: "24px",
    height: "24px"
});
//# sourceMappingURL=data:application/json;base64,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